import React from "react";
import "./skills.css";

import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaBootstrap, FaAngular } from "react-icons/fa";
import { SiRedux, SiTailwindcss, SiVite, SiFigma, SiGithub, SiPostman } from "react-icons/si";

const skills = [
  { name: "HTML", icon: <FaHtml5 />, color: "#e34c26" },
  { name: "CSS", icon: <FaCss3Alt />, color: "#264de4" },
  { name: "JavaScript", icon: <FaJs />, color: "#f0db4f" },
  { name: "React", icon: <FaReact />, color: "#61dafb" },
  { name: "Redux", icon: <SiRedux />, color: "#764abc" },
  { name: "Tailwind", icon: <SiTailwindcss />, color: "#38bdf8" },
  { name: "Bootstrap", icon: <FaBootstrap />, color: "#7952b3" },
  { name: "Angular", icon: <FaAngular />, color: "#dd0031" },
  { name: "API", icon: <SiPostman />, color: "#ff6c37" },
  { name: "Vite", icon: <SiVite />, color: "#646cff" },
  { name: "Figma", icon: <SiFigma />, color: "#a259ff" },
  { name: "GitHub", icon: <SiGithub />, color: "#6e5494" },
];

export default function Skills() {
  return (
    <section className="skills-section">
      <h2 className="section-title">My Skills</h2>
      <div className="skills-grid">
        {skills.map((skill, index) => (
          <div
            key={index}
            className="skill-item"
            style={{ borderColor: skill.color }}
          >
            <div className="icon-wrapper" style={{ color: skill.color }}>
              {skill.icon}
            </div>
            <span>{skill.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
